// extracted by mini-css-extract-plugin
module.exports = {"menu":"e_oE","alignRight":"e_pE","alignLeft":"e_qE","item":"e_rE","icon":"e_sE","soft":"e_tE"};